import { createContext } from "react";

export const ElementContext = createContext();